import Vue from 'vue';

// 通用 Vue.config 配置
Vue.config.silent = true;
